import styleInject from './../../externals/style-inject/dist/style-inject.es.js';

var css_248z = ".CVVIcon-module_cvvIcon__sBYUq {\n  line-height: normal;\n  height: 24px;\n}";
var styles = {"cvvIcon":"CVVIcon-module_cvvIcon__sBYUq"};
styleInject(css_248z);

export { styles as default };
//# sourceMappingURL=CVVIcon.module.scss.js.map
